module.exports = __webpack_public_path__ + "r-v3/img/download.9184863f.svg";